
export const getReferrer = () => {
  const referrerUrl = document.referrer;
  if (referrerUrl) {
    const url = new URL(referrerUrl);
    const host = url.hostname;
    return host;
  }
  return null;
};

export const isFromSpecificSite = (referrer) => {
  const specificSites = [
    'view.oneroomstreaming.com',
  ];

  return specificSites.some(site => referrer === site);
};